module.exports = __webpack_public_path__ + "static/TrailerPoster-764f6a75328930d8bfd87985906f7337.jpg";